var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      background: "transparent"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 14,
    width: 12,
    height: 20,
    rx: 1.5,
    fill: "none",
    stroke: "#E8A020",
    strokeWidth: 1.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 18,
    width: 3,
    height: 3,
    rx: 0.5,
    fill: "#E8A020"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 18,
    width: 3,
    height: 3,
    rx: 0.5,
    fill: "#E8A020"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 24,
    width: 3,
    height: 3,
    rx: 0.5,
    fill: "#E8A020"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 24,
    width: 3,
    height: 3,
    rx: 0.5,
    fill: "#E8A020"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 14,
    width: 12,
    height: 20,
    rx: 1.5,
    fill: "none",
    stroke: "#E8A020",
    strokeWidth: 1.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 18,
    width: 3,
    height: 3,
    rx: 0.5,
    fill: "#E8A020"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 18,
    width: 3,
    height: 3,
    rx: 0.5,
    fill: "#E8A020"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 24,
    width: 3,
    height: 3,
    rx: 0.5,
    fill: "#E8A020"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 24,
    width: 3,
    height: 3,
    rx: 0.5,
    fill: "#E8A020"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 8,
    width: 12,
    height: 26,
    rx: 1.5,
    fill: "none",
    stroke: "#E8A020",
    strokeWidth: 1.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 12,
    width: 3,
    height: 3,
    rx: 0.5,
    fill: "#E8A020"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 12,
    width: 3,
    height: 3,
    rx: 0.5,
    fill: "#E8A020"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 18,
    width: 3,
    height: 3,
    rx: 0.5,
    fill: "#E8A020"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 18,
    width: 3,
    height: 3,
    rx: 0.5,
    fill: "#E8A020"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 28,
    width: 4,
    height: 6,
    rx: 0.5,
    fill: "#E8A020"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 34.5,
    x2: 37,
    y2: 34.5,
    stroke: "#E8A020",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/companies.473640696ea4441c45d4bf4fdf49dd1b.svg";
export { ForwardRef as ReactComponent };